module.exports = __webpack_public_path__ + "static/media/q1_2023.9b6368ee.png";